const FILE_STYLES = {
  image: { color: "#9333ea", bg: "#faf5ff", border: "#f3e8ff", hoverBg: "#f3e8ff" },
  pdf: { color: "#dc2626", bg: "#fef2f2", border: "#fee2e2", hoverBg: "#fee2e2" },
  excel: { color: "#16a34a", bg: "#f0fdf4", border: "#dcfce7", hoverBg: "#dcfce7" },
  doc: { color: "#2563eb", bg: "#eff6ff", border: "#dbeafe", hoverBg: "#dbeafe" },
  default: { color: "#6366f1", bg: "#eef2ff", border: "#e0e7ff", hoverBg: "#e0e7ff" },
};

function getFileType(ext) {
  if (["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(ext)) return "image";
  if (ext === "pdf") return "pdf";
  if (["xlsx", "xls", "csv"].includes(ext)) return "excel";
  if (["doc", "docx"].includes(ext)) return "doc";
  return "default";
}

function AttachmentList({ urls }) {
  if (!urls || urls.length === 0) return null;

  return (
    <div className="d-flex flex-wrap gap-2">
      {urls.map((url, i) => {
        const fileName = decodeURIComponent(
          url.split("/").pop().replace(/^[a-f0-9]+_/, "")
        );
        const ext = fileName.split(".").pop().toLowerCase();
        const type = getFileType(ext);
        const isImage = type === "image";
        const style = FILE_STYLES[type];

        if (isImage) {
          return (
            <a
              key={i}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-3 overflow-hidden d-inline-block"
              style={{
                border: "1px solid #e8e8e8",
                maxWidth: "140px",
                textDecoration: "none",
              }}
            >
              <img
                src={url}
                alt={fileName}
                className="d-block"
                style={{ width: "100%", height: "auto" }}
              />
              <div
                className="text-center text-truncate px-2 py-1"
                style={{
                  fontSize: "0.7rem",
                  color: style.color,
                  background: style.bg,
                }}
              >
                {fileName}
              </div>
            </a>
          );
        }

        return (
          <a
            key={i}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="d-inline-flex align-items-center gap-1"
            style={{
              fontSize: "0.8rem",
              color: style.color,
              background: style.bg,
              padding: "4px 10px",
              borderRadius: "6px",
              textDecoration: "none",
              border: `1px solid ${style.border}`,
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = style.hoverBg)}
            onMouseOut={(e) => (e.currentTarget.style.background = style.bg)}
          >
            <i
              className={`bi ${
                type === "pdf"
                  ? "bi-file-earmark-pdf"
                  : type === "excel"
                  ? "bi-file-earmark-spreadsheet"
                  : type === "doc"
                  ? "bi-file-earmark-word"
                  : "bi-file-earmark"
              }`}
              style={{ fontSize: "0.85rem" }}
            />
            {fileName}
          </a>
        );
      })}
    </div>
  );
}

function CardDetails({ object }) {
  console.log("Card", object);
  const formatDate = (date, locale = "en-PH") =>
    date &&
    new Date(date).toLocaleString(locale, {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Manila",
    });

  const isCompleted = object?.status === "Completed";

  const DetailRow = ({ icon, label, value }) =>
    value ? (
      <div className="d-flex align-items-start gap-3 py-2">
        <div
          className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
          style={{
            width: "36px",
            height: "36px",
            backgroundColor: "#edf7e1",
            color: "#82c14a",
          }}
        >
          <i className={`bi ${icon}`} style={{ fontSize: "1rem" }} />
        </div>
        <div>
          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>
            {label}
          </small>
          <span
            className="fw-semibold text-dark"
            style={{ fontSize: "0.9rem" }}
          >
            {value}
          </span>
        </div>
      </div>
    ) : null;

  return (
    <div
      className="mt-3 rounded-3 overflow-hidden"
      style={{
        border: "1px solid #e8e8e8",
        background: "#fff",
      }}
    >
      {/* Header */}
      <div
        className="px-4 py-3 d-flex align-items-center gap-2"
        style={{
          background: "linear-gradient(135deg, #82c14a 0%, #6ba83a 100%)",
        }}
      >
        <i className="bi bi-info-circle-fill text-white" />
        <h6 className="mb-0 text-white fw-bold" style={{ fontSize: "0.95rem" }}>
          Request Details
        </h6>
      </div>

      {/* Body */}
      <div className="px-4 py-3">
        {isCompleted ? (
          <>
            <DetailRow
              icon="bi-shop"
              label="Store"
              value={object?.sourceLocation?.name}
            />
            <DetailRow
              icon="bi-clock-history"
              label="Est. Delivery Time"
              value={formatDate(object?.estimatedDeliveryTime)}
            />
            <DetailRow
              icon="bi-truck"
              label="Delivery Time"
              value={formatDate(object?.deliveryTime)}
            />
            <DetailRow
              icon="bi-chat-left-text"
              label="Remarks"
              value={object?.remarks}
            />
          </>
        ) : object?.status === "For Reconciliation" ? (
          <>
            <DetailRow
              icon="bi-shop"
              label="Store"
              value={object?.destinationLocation?.name}
            />
            <DetailRow
              icon="bi-calendar-event"
              label="Request Date"
              value={formatDate(object?.requestDate, "en-US")}
            />
            <DetailRow
              icon="bi-chat-left-text"
              label="Reconcile Remarks"
              value={object?.reconcileRemarks}
            />
            {object?.uploadAttach?.length > 0 && (
              <div
                className="mt-3 pt-3"
                style={{ borderTop: "1px solid #f0f0f0" }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    style={{
                      width: "36px",
                      height: "36px",
                      backgroundColor: "#edf7e1",
                      color: "#82c14a",
                    }}
                  >
                    <i
                      className="bi bi-paperclip"
                      style={{ fontSize: "1rem" }}
                    />
                  </div>
                  <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                    Attachments
                  </small>
                </div>
                <AttachmentList urls={object.uploadAttach} />
              </div>
            )}
          </>
        ) : (
          <>
            <DetailRow
              icon="bi-shop"
              label="Store"
              value={object?.destinationLocation?.name}
            />
            <DetailRow
              icon="bi-calendar-event"
              label="Request Date"
              value={formatDate(object?.requestDate, "en-US")}
            />
            <DetailRow
              icon="bi-chat-left-text"
              label="Remarks"
              value={object?.remarks}
            />

            {object?.attachment && (
              <div
                className="mt-3 pt-3"
                style={{ borderTop: "1px solid #f0f0f0" }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    style={{
                      width: "36px",
                      height: "36px",
                      backgroundColor: "#edf7e1",
                      color: "#82c14a",
                    }}
                  >
                    <i
                      className="bi bi-paperclip"
                      style={{ fontSize: "1rem" }}
                    />
                  </div>
                  <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                    Attachment
                  </small>
                </div>
                <AttachmentList
                  urls={
                    Array.isArray(object.attachment)
                      ? object.attachment
                      : [object.attachment]
                  }
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CardDetails;
